import Alpine from 'alpinejs';

import collapse from '@alpinejs/collapse';
import focus from '@alpinejs/focus';

import calculator from './calculator';

window.Alpine = Alpine;

Alpine.plugin(collapse);
Alpine.plugin(focus);

Alpine.store('calculator', calculator);

Alpine.start();
